import { render, staticRenderFns } from "./Plyr.vue?vue&type=template&id=6e45678f&"
import script from "./Plyr.vue?vue&type=script&lang=js&"
export * from "./Plyr.vue?vue&type=script&lang=js&"
import style0 from "plyr/dist/plyr.css?vue&type=style&index=0&lang=css&"
import style1 from "./Plyr.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports